var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-shimmer"},[_c('HeaderShimer',{style:({ width: '100%' })}),_c('ChartShimer',{style:({ width: '100%' })}),_c('div',{staticClass:"dashboard-shimmer__table"},_vm._l((Array(12)),function(item){return _c('ShimmerLoader',{key:item,staticClass:"dashboard-shimmer__table-item"})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }